export const ASSOCIATION_LEVEL_INDEX = 0;
export const ACCOUNT_NUMBER_INDEX = 1;
export const LOYALTY_DETAILS_INDEX = 2;
export const TERMS_AND_CONDITIONS_INDEX = 3;

export const FIXED_HEADER_OFFSET = -175;
